"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CartList_1 = __importDefault(require("../../Components/CartList"));
var CheckoutSummary_1 = __importDefault(require("../../Components/CheckoutSummary"));
function CartPage() {
  var cart = reconnect_js_1.useOutlet('cart')[0];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(antd_1.Card, null, react_1.default.createElement(antd_1.Divider, {
    orientation: "center"
  }, "\u8CFC\u7269\u8ECA"), cart.items.length === 0 && react_1.default.createElement("div", null, react_1.default.createElement("h3", {
    style: {
      margin: '10px 0'
    }
  }, "\u60A8\u76EE\u524D\u7684\u8CFC\u7269\u8ECA\u70BA\u7A7A!"), react_1.default.createElement(antd_1.Button, {
    onClick: function () {
      return AppActions.navigate('/products');
    }
  }, "\u99AC\u4E0A\u9078\u8CFC")), cart.items.length > 0 && react_1.default.createElement(CartList_1.default, {
    cartItems: cart.items
  }), react_1.default.createElement(CheckoutSummary_1.default, {
    cart: cart,
    onClick: function () {
      return AppActions.navigate('/checkout/info');
    },
    disabled: cart.items.length === 0
  })));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"])));
exports.default = CartPage;
var templateObject_1;